import React from 'react';
import ReactDOMServer from 'react-dom/server';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// import Markdown from 'markdown-to-jsx';
import ReactDOM from "react-dom/client";
import MarkDownText from "../components/MarkDownText/MarkDownText";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

export const generarPdfImprimir = (data) => {
  console.log("generarPdf data", data);
  const newWindow = window.open("", "_blank");

  if (!newWindow) {
    alert("No se pudo abrir la ventana de vista previa.");
    return;
  }

  // Links externos (fuente Montserrat + KaTeX)
  const externalLinks = `
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap"
      rel="stylesheet"
    />
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/katex@0.16.11/dist/katex.min.css"
      integrity="sha384-Rb9HhtfKQy9yE4zRzSglKzQJ2OEQnZt2H3bqCkJ6M2b8e7dO6kGm8r6dVwH2eQw6"
      crossorigin="anonymous"
    />
  `;

  // Estilos base + impresión
  const styles = `
   <style>
  :root { --brand-blue: #336B87; --thead-bg: #90AFC5; }
  @page { size: A4; margin: 16mm; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    a[href] { text-decoration: none; color: inherit; }
    .MuiTooltip-popper, .download-btn { display: none !important; }
    th, td { font-size: 14px; } /* un poco más compacto en PDF */
  }

  html, body {
    font-family: 'Montserrat', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji';
    font-size: 16px;
    color: rgba(0,0,0,0.8);
    margin: 0;
    padding: 20px;
  }
  h1, h2, h3, h4, h5, h6 { font-weight: 700; color: var(--brand-blue); margin: 0.6em 0 0.4em; }
  p, li, td { text-align: justify; }
  img { max-width: 100%; height: auto; }

  /* ===== Alineación y envoltura dentro de tablas ===== */

/* Centra SOLO los encabezados si quieres */
thead th { text-align: center; }

/* Celdas: izquierda por defecto (evita el espaciado raro) */
td { text-align: left; }

/* Justifica SOLO el texto interno (p, li), no toda la celda */
td p, td li { text-align: justify; }

/* Quita márgenes de los párrafos dentro de celdas */
td p, th p { margin: 0; }

/* Listas dentro de celdas: márgenes controlados */
td ul, td ol { margin: 0; padding-left: 18px; }

/* Asegura que no quede “aire” extra por primer/último hijo */
td > :first-child { margin-top: 0; }
td > :last-child  { margin-bottom: 0; }

/* (Mantén) buena envoltura y altura razonable */
th, td {
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: anywhere;
  hyphens: auto;
  line-height: 1.35; /* un poco más compacto que 1.45 */
  font-family: 'Montserrat', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
}

/* Si necesitas tabla estable, mantén table-layout: fixed */
table { table-layout: fixed; page-break-inside: auto; }

/* Repite header en cada página y evita cortar filas */
thead { display: table-header-group; }
tfoot { display: table-footer-group; }
tr    { break-inside: avoid; page-break-inside: avoid; }
</style>

  `;

  // Documento base de la ventana nueva
  newWindow.document.open();
  newWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>UmmIA - Proyecto</title>
        <link rel="icon" href="./icon/LOGO_TUCLASE.ico" />
        ${externalLinks}
        ${styles}
      </head>
      <body>
        <div id="content"></div>
      </body>
    </html>
  `);
  newWindow.document.close();

  // Renderizar el componente dentro de la nueva ventana
  newWindow.onload = () => {
    const contentElement = newWindow.document.getElementById("content");

    if (contentElement) {
      // 🔧 Cache de Emotion apuntando al <head> de la nueva ventana (para estilos MUI)
      const cache = createCache({
        key: "printwin",
        container: newWindow.document.head,
        prepend: true,
      });

      const root = ReactDOM.createRoot(contentElement);

      // Si NO usas MUI/Emotion dentro del preview, puedes renderizar <MarkDownText ... /> directamente.
      root.render(
        <CacheProvider value={cache}>
          <MarkDownText data={data}  />
        </CacheProvider>
      );

      // Imprimir y cerrar
      const handlePrintAndClose = () => {
        const closeNewWindow = () => newWindow.close();
        const handleFocus = () => setTimeout(closeNewWindow, 500);

        newWindow.print();
        newWindow.onfocus = handleFocus;
      };

      // Espera breve para asegurarse de que se montó todo (fuentes/estilos)
      setTimeout(handlePrintAndClose, 600);
    } else {
      console.error("No se encontró el elemento 'content' en la nueva ventana.");
    }
  };
};